module.exports = __webpack_public_path__ + "img/added-service-unit-09.76a275c5.png";